import Index from '../../pages/servitor/nySign/index';

const base = 'nySign';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/servitor/nySign.js